<template>
  <v-navigation-drawer
    v-if="isAuthorized"
    class="left-menu"
    :width="172"
    :rail-width="56"
    location="left"
    floating
    permanent
    :rail="isMenuMini"
  >
    <div class="d-flex flex-column justify-space-between px-1" style="height: 100%">
      <v-list density="compact">
        <div
          class="d-flex align-center"
          :class="isMenuMini ? 'flex-column' : 'justify-space-between left-menu__logo-wrapper'"
        >
          <!-- Логотип, по нажатию открывает главную -->
          <router-link to="/" custom v-slot="{ navigate }">
            <div
              class="left-menu__logo"
              :class="!isMenuMini ? 'left-menu__logo-max' : ''"
              style="cursor: pointer; margin-bottom: 11px; margin-top: 15px"
              @click="navigate"
            >
              <img
                alt="Логотип Зарбо"
                :src="!isMenuMini ? ZarboLogo : ZarboLogoAr"
                :style="{ width: isMenuMini ? '32px' : '100%' }"
              />
            </div>
          </router-link>
          <TeamsMenu :mini="isMenuMini" />
        </div>
        <template v-for="item in topMenu">
          <PermissionWrapperVue
            v-if="item.permission"
            :key="item.title"
            :billingValue="item.permission.billingValue"
            :billingCode="item.permission.billingCode"
            :permissionCode="item.permission.permissionCode"
            :textStyles="item.permission.textStyles"
            :iconStyles="item.permission.iconStyles"
          >
            <LeftMenuItem
              :item="item"
              :mini="isMenuMini"
              :active="isMenuItemActive(item)"
              @click="onTopMenuClick(item)"
            />
          </PermissionWrapperVue>
          <LeftMenuItem
            v-else
            :key="item.title + 'pupus'"
            :item="item"
            :mini="isMenuMini"
            :active="isMenuItemActive(item)"
            @click="onTopMenuClick(item)"
          />
        </template>
      </v-list>
      <v-list density="compact">
        <template v-for="item in bottomMenu">
          <PermissionWrapperVue
            v-if="item.permission"
            :key="item.title"
            :billingValue="item.permission.billingValue"
            :billingCode="item.permission.billingCode"
            :permissionCode="item.permission.permissionCode"
            :textStyles="item.permission.textStyles"
            :iconStyles="item.permission.iconStyles"
            :style="item.permission.wrapperStyle"
          >
            <LeftMenuItem
              :item="item"
              :mini="isMenuMini"
              :active="item.ignoreActive ? false : isMenuItemActive(item)"
              @click="onBottomMenuClick(item)"
            />
          </PermissionWrapperVue>
          <LeftMenuItem
            v-else
            :key="item.title + 'pupus'"
            :item="item"
            :mini="isMenuMini"
            :active="item.ignoreActive ? false : isMenuItemActive(item)"
            @click="onBottomMenuClick(item)"
          />
        </template>
        <HelpMenu
          :item="helpMenuItem"
          :mini="isMenuMini"
          :active="helpMenuItem.ignoreActive ? false : isMenuItemActive(helpMenuItem)"
          @select="onHelpMenuSelect"
        />
        <div class="left-menu__minimize" @click="isMenuMini = !isMenuMini">
          <TipsVue
            v-if="isMenuMini"
            :keyTips="'expand'"
            content-class="zarbo-tips__home-page tooltip-right__home-page"
          >
            <v-icon color="#A09BCC" icon="openLeftMenu" />
          </TipsVue>
          <v-icon v-else color="#A09BCC" icon="closeLeftMenu" />
          <p v-if="!isMenuMini" class="left-menu__item-title ml-3">Свернуть</p>
        </div>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "pinia";

import ZarboLogoAr from "@/assets/img/zarbo-logo-ar.svg";
import ZarboLogo from "@/assets/img/zarbo-logo.png";
import HelpMenu from "@/components/Navigation/HelpMenu.vue";
import LeftMenuItem from "@/components/Navigation/LeftMenuItem.vue";
import TeamsMenu from "@/components/Navigation/TeamsMenu.vue";
import { GET_TAGS } from "@/components/Tags/service/api";
import PermissionWrapperVue from "@/components/Utils/PermissionWrapperVue.vue";
import TipsVue from "@/components/Utils/TipsVue.vue";
import { useAppStore, useTeamStore } from "@/store/modules";

import useTagStore from "../../store/modules/tagStore";

export default {
  name: "navigation-menu",
  components: { TeamsMenu, TipsVue, HelpMenu, LeftMenuItem, PermissionWrapperVue },
  props: ["isAuthorized"],
  data: () => ({
    isMenuMini: false,
    topMenu: [
      {
        title: "Коллекции",
        icon: "folders",
        key: 0,
        tips: "collections",
        method: "openHomePage",
      },
      {
        title: "Теги",
        icon: "tags",
        key: 1,
        tips: "tags",
        method: "openTags",
      },
      {
        title: "Библиотека материалов",
        icon: "MaterialLibraryNav",
        key: 2,
        tips: "material-library",
        method: "openMaterialLibrary",
        permission: {
          billingValue: -2,
          billingCode: "access_library",
          textStyles: { paddingTop: "14px", paddingBottom: "14px" },
          iconStyles: { right: "1px", top: "1px" },
        },
      },
      {
        title: "Рендеры",
        icon: "render",
        key: 3,
        tips: "renders",
        method: "openRender",
        permission: {
          billingValue: -2,
          billingCode: "render360",
          textStyles: { paddingTop: "14px", paddingBottom: "14px" },
          iconStyles: { right: "1px", top: "1px" },
        },
      },
      {
        title: "AI-фото",
        icon: "aiPhoto",
        key: 4,
        tips: "ai-photo",
        method: "openAiPhoto",
        permission: {
          billingValue: -2,
          billingCode: "ai_gen",
          permissionCode: "read_ai_generator",
          textStyles: { paddingTop: "14px", paddingBottom: "14px" },
          iconStyles: { right: "1px", top: "1px" },
        },
      },
    ],
    bottomMenu: [
      {
        title: "Аналитика",
        icon: "analitics",
        key: 5,
        tips: "analitics",
        method: "openAnalytics",
        preserveSelection: true,
        ignoreActive: true,
        permission: {
          billingCode: "access_analytic",
          textStyles: { paddingTop: "14px", paddingBottom: "14px" },
          iconStyles: { right: "1px", top: "1px" },
        },
      },
    ],
    helpMenuItem: {
      title: "Помощь",
      icon: "help",
      key: 6,
      tips: "help",
      preserveSelection: true,
      ignoreActive: true,
    },
    selectedMenuKey: 0,
    lastSelectedMenuKey: undefined,
    ZarboLogo,
    ZarboLogoAr,
  }),
  computed: {
    ...mapState(useTeamStore, {
      selectedTeam: (state) => state.selectedTeam,
    }),
    currentRoutePath() {
      return this.$route.path;
    },
    routeKey() {
      const tab = this.$route.query.tab || "";
      return `${this.$route.path}?tab=${tab}`;
    },
  },
  watch: {
    isAuthorized: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAllTags();
        }
      },
    },
    selectedTeam() {
      if (this.isAuthorized) {
        this.getAllTags();
      }
    },
    routeKey() {
      this.syncMenuSelection();
      if (this.isAuthorized && !useTagStore().tags.length) {
        this.getAllTags();
      }
    },
    isMenuMini(newVal) {
      localStorage.setItem("navMenuMini", String(newVal));
    },
    selectedMenuKey(newVal, oldVal) {
      this.lastSelectedMenuKey = oldVal;
      localStorage.setItem("selectedTab", newVal);

      if (newVal !== undefined && newVal !== null) {
        useAppStore().SET_VALUE({
          key: "lastSelectedTab",
          value: newVal,
        });
      }
    },
  },
  created() {
    this.initializeMiniState();
    this.syncMenuSelection();
  },
  methods: {
    async getAllTags() {
      if (!this.isAuthorized) {
        return;
      }
      if (
        this.$route.path === "/login" ||
        this.$route.path.startsWith("/oauth/") ||
        this.$route.path.startsWith("/social/")
      ) {
        return;
      }
      if (!localStorage.getItem("zarboAccessToken")) {
        return;
      }
      try {
        const teamSlug = localStorage.getItem("selectedTeamSlug") || this.selectedTeam?.team?.slug || null;
        const tags = await GET_TAGS(teamSlug ? { team: teamSlug } : null);
        useTagStore().SET_VALUE({
          key: "tags",
          value: tags,
        });
      } catch (error) {
        console.error(error);
      }
    },
    initializeMiniState() {
      const stored = localStorage.getItem("navMenuMini");
      if (stored === null) return;
      this.isMenuMini = stored === "true";
    },
    getMenuKeyByRoute(path) {
      if (path === "/") {
        return this.$route.query.tab === "tags" ? 1 : 0;
      }
      if (path.startsWith("/product")) return 0;
      if (path === "/material-library" || path.startsWith("/material-library/")) return 2;
      if (path === "/render" || path.startsWith("/render/")) return 3;
      if (path === "/ai" || path.startsWith("/ai/")) return 4;
      return null;
    },
    isMenuItemActive(item) {
      return this.getMenuKeyByRoute(this.currentRoutePath) === item.key;
    },
    syncMenuSelection() {
      const key = this.getMenuKeyByRoute(this.currentRoutePath);
      if (key !== null && key !== undefined) {
        this.selectedMenuKey = key;
      }
    },
    openAiPhoto() {
      if (this.$route.path !== "/ai") {
        this.$router.push("/ai");
      }
    },
    openTags() {
      if (this.$route.path === "/" && this.$route.query.tab === "tags") {
        return;
      }
      this.$router.push({ path: "/", query: { tab: "tags" } });
    },
    openHomePage() {
      if (this.$route.path === "/" && !this.$route.query.tab) {
        return;
      }
      this.$router.push({ path: "/" });
    },
    openMaterialLibrary() {
      if (this.$route.path !== "/material-library") {
        this.$router.push("/material-library");
      }
    },
    openRender() {
      if (this.$route.path !== "/render") {
        this.$router.push("/render");
      }
    },
    onHelpMenuSelect() {
      if (this.helpMenuItem.preserveSelection) return;
    },
    onTopMenuClick(item) {
      this.callMenu(item.method);
    },
    onBottomMenuClick(item) {
      this.callMenu(item.method);
    },
    closeMenu() {
      this.isMenuMini = !this.isMenuMini;
    },
    openAnalytics() {
      const url = this.selectedTeam && this.selectedTeam.team && this.selectedTeam.team.public_url;
      if (url) {
        window.open(url, "_blank", "noopener");
      }
    },
    callMenu(name) {
      const fn = this[name];
      if (typeof fn === "function") fn();
    },
  },
};
</script>

<style lang="scss">
.left-menu {
  min-width: 56px;
  border-radius: 10px !important;
  background-color: rgb(var(--v-theme-primary)) !important;
  margin: 4px 12px 4px 4px;
  max-height: calc(100% - 8px) !important;
  overflow: visible;
  border: none !important;
  box-shadow: none !important;

  .v-list {
    padding: 0;
  }

  &__logo {
    width: 79px;
    height: 17px;
    margin: 0 auto;
    margin-top: 8px;
    margin-bottom: 16px;
    img {
      height: 17px;
      object-fit: contain;
      margin-left: 12px;
    }
  }
  &__logo-wrapper {
    margin: 0;
    margin-bottom: 8px;
  }
  &__logo-max {
    margin: 0;
  }
  &__item {
    border-radius: 10px;
    background: #3f3273;
    margin-bottom: 4px;
    padding-inline: 12px !important;
    height: 48px;
    width: 100%;
    --v-list-prepend-gap: 0px;

    &-title {
      color: #a09bcc;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: 105% !important;
      white-space: normal;
    }

    .v-list-item__prepend {
      align-self: center;
    }

    .v-list-item__spacer {
      width: 0;
    }

    .v-list-item__content {
      padding: 0;
    }

    > .v-list-item__overlay {
      opacity: 0 !important;
    }
  }
  &__item--active,
  &__item--active:hover {
    background: #fff;
    position: relative;

    .left-menu__item-title {
      color: rgb(var(--v-theme-primary));
    }

    .v-icon {
      color: rgb(var(--v-theme-primary)) !important;
    }
    .v-list-item__prepend > .v-icon {
      opacity: 1 !important;
    }
  }
  &__item--active::after {
    content: "";
    display: block;
    position: absolute;
    left: auto !important;
    right: -4px !important;
    top: 19px !important;
    width: 4px !important;
    height: 8px !important;
    background-image: url("@/assets/img/menu-active-item.svg");
    background-repeat: no-repeat;
    background-size: contain;
    z-index: 1;
    pointer-events: none;
  }
  &__item:hover {
    background-color: rgb(var(--v-theme-secondary));
    .left-menu__item-title {
      color: rgb(var(--v-theme-primary));
    }
    svg {
      color: rgb(var(--v-theme-primary)) !important;
    }
    .v-list-item__prepend > .v-icon {
      opacity: 1 !important;
    }
  }
  &__item--active:hover {
    background: #fff;
  }

  &__minimize {
    display: flex;
    align-items: center;
    height: 48px;
    margin-left: 12px;
    cursor: pointer;
  }
  &__minimize:hover {
    svg {
      color: rgb(var(--v-theme-secondary)) !important;
    }
    .left-menu__item-title {
      color: rgb(var(--v-theme-secondary));
    }
  }
}
.left-menu .v-navigation-drawer__content {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.left-menu .v-navigation-drawer__content::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.left-menu.v-navigation-drawer--rail .left-menu__teams > *:not(:first-child) {
  clip: auto;
  clip-path: none;
}

.left-menu.v-navigation-drawer--rail .left-menu__logo img {
  margin-left: 8px;
}

.left-menu.v-navigation-drawer--rail .left-menu__item {
  padding-inline: 0;
  justify-content: flex-start;
}

.left-menu.v-navigation-drawer--rail .left-menu__badge .left-menu__item--help {
  width: 48px;
}

.left-menu.v-navigation-drawer--rail .left-menu__item-title {
  display: none;
}

.left-menu.v-navigation-drawer--rail .left-menu__item .v-icon {
  margin-right: 0 !important;
}

.left-menu__badge {
  display: block;
  .v-badge__badge {
    top: 4px !important;
    right: -10px !important;
  }
}

.mini-user-info {
  width: 191px;
  max-height: 300px;
  border: none;
  background-color: rgb(var(--v-theme-primary));
  border-radius: 10px !important;
  box-shadow: none;

  &__tg-btn {
    padding-left: 0;
    &.v-btn {
      border-radius: 10px 10px 0 0;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;

    .v-btn__content {
      // padding-left: 150px;
      color: white !important;
      // justify-content: flex-start;
    }
  }
}

.user-support {
  width: 191px;

  &-text {
    font-style: normal;
    font-weight: 400;
    letter-spacing: normal;
    padding-right: 0;
    border-radius: 0 0 10px 10px;

    .v-btn__content {
      padding-left: 0;
      text-transform: none;
      font-size: 16px !important;
      line-height: 22px !important;
    }

    &.v-btn {
      padding-right: 0 !important;
    }
  }

  &-text:hover {
    background-color: #3f3273;
  }

  &__new {
    border-radius: 4px;
    background: #e85a63;
    width: 34px;
    padding: 3px 4px 2px 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 16px;
    color: white;
  }
}
</style>
